/**
 * Author : zhengyanfeng.
 * Date   : 2021/1/5.
 * File   : province. 省份id对象
 */
export default {
  '86': require('../../static/mapVideos/china.mp4'),
  '350000': require('../../static/mapVideos/fujian/index.mp4'),
  '350100': require('../../static/mapVideos/fujian/fuzhou.mp4'),
  '350200': require('../../static/mapVideos/fujian/xiamen.mp4'),
  '350900': require('../../static/mapVideos/fujian/ningde.mp4'),
  '330000': require('../../static/mapVideos/zhejiang/index.mp4'),
  '330300': require('../../static/mapVideos/zhejiang/wenzhou.mp4')
}



//////////////////
// WEBPACK FOOTER
// ./static/mapVideos/index.js
// module id = SAF8
// module chunks = 6